import { ThisConnector } from '../../../../api/connector'

export interface GetOrganizationSettingsArgs {
  organizationUuid: string
}

export interface GetOrganizationSettingsResponse {
  messages: Array<string> | []
  success: boolean
  diagnosticsCollectionEnabled: boolean
  restrictedEditRoleEnabled: boolean
  isEOP: boolean
  agentUrl: string | undefined
  aimlServiceEnabled: boolean
}

export async function getOrganizationSettings(
  this: ThisConnector,
  { organizationUuid }: GetOrganizationSettingsArgs
) {
  return this.connector.get<GetOrganizationSettingsResponse>(
    `/${organizationUuid}/organizations/general/settings`
  )
}
